import { render, staticRenderFns } from "./MiDataTableBulkAction.vue?vue&type=template&id=cfed88ac&"
import script from "./MiDataTableBulkAction.vue?vue&type=script&lang=ts&"
export * from "./MiDataTableBulkAction.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports